import { isNull, isStringNull } from "@/shared/utils/utils";

export const highlightFilter = (text: any, searchString: string) => {
    if (isNull(text) || isStringNull(searchString)) return text;

    if (typeof text !== "string") {
        throw new Error("Highlight Filter accepts only string value.");
    }

    return (text || "").replace(new RegExp(searchString, "gi"), match => {
        return `<span class="bg-success text-white px-1 rounded">${match}</span>`;
    });
};
